<template>
  <shop-item-base :item="item">
    <template v-slot:footer>
      <v-row>
        <v-col style="font-size: 14px;">
          <p>
            <v-icon color="yellow" icon="mdi-star" class="mr-1"/>
            <span v-if="currency">{{ currency === 'points' ? $t('shop.points.cost', {price: item.price}) : `${item.price} ${currency}` }}</span>
          </p>
          <p>
            <v-icon color="blue" icon="mdi-package-variant" class="mr-1"/>
            <span v-if="item.stock !== -1">{{ item.stock}}</span>
            <v-icon size="14" v-else icon="mdi-infinity"/>
            <span>&nbsp;{{ $t('shop.remaining.stock') }}</span>
          </p>
        </v-col>
        <v-col>
          <kicklet-button :disabled="item.stock <= 0 && item.stock !== -1" class="float-end" @click="buyConfirmDialog.display = true">{{ $t('buy') }}</kicklet-button>
        </v-col>
      </v-row>
    </template>
  </shop-item-base>
  <buy-shop-item-dialog
    v-model="buyConfirmDialog"
    :item="item"
    :command="settings?.command"
  />
</template>

<script setup>
import KickletButton from '@/components/custom/kicklet/KickletButton.vue';
import ShopItemBase from '@/views/shop/ShopItemBase.vue';
import { ref } from 'vue';
import BuyShopItemDialog from '@/components/dialog/BuyShopItemDialog.vue';

defineProps({
  item: {
    type: Object,
    required: true,
  },
  settings: {
    type: Object,
    required: true,
  },
  currency: {
    type: String,
  },
});

const buyConfirmDialog = ref({
  display: false,
});
</script>

<style scoped>
</style>
